export default __webpack_public_path__ + "static/media/brand_img1.a52dcbe9.jpg";